var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPostLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "location_on"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_369_9393",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.88916,
    y: 0.787842,
    width: 19.2569,
    height: 19.2569,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_369_9393)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "location_on_2",
    d: "M10.5176 10.4163C10.9589 10.4163 11.3367 10.2592 11.6509 9.94489C11.9652 9.63063 12.1223 9.25285 12.1223 8.81154C12.1223 8.37024 11.9652 7.99246 11.6509 7.6782C11.3367 7.36393 10.9589 7.2068 10.5176 7.2068C10.0763 7.2068 9.69851 7.36393 9.38425 7.6782C9.06999 7.99246 8.91286 8.37024 8.91286 8.81154C8.91286 9.25285 9.06999 9.63063 9.38425 9.94489C9.69851 10.2592 10.0763 10.4163 10.5176 10.4163ZM10.5176 16.3137C12.1491 14.816 13.3593 13.4553 14.1483 12.2317C14.9373 11.008 15.3318 9.92149 15.3318 8.97202C15.3318 7.51438 14.8671 6.32085 13.9377 5.39144C13.0083 4.46203 11.8683 3.99732 10.5176 3.99732C9.16694 3.99732 8.02691 4.46203 7.09749 5.39144C6.16808 6.32085 5.70337 7.51438 5.70337 8.97202C5.70337 9.92149 6.09787 11.008 6.88687 12.2317C7.67587 13.4553 8.88611 14.816 10.5176 16.3137ZM10.5176 18.44C8.36457 16.6079 6.75649 14.9062 5.69334 13.3349C4.6302 11.7636 4.09863 10.3093 4.09863 8.97202C4.09863 6.96609 4.74387 5.36804 6.03435 4.17785C7.32483 2.98767 8.81925 2.39258 10.5176 2.39258C12.216 2.39258 13.7104 2.98767 15.0008 4.17785C16.2913 5.36804 16.9366 6.96609 16.9366 8.97202C16.9366 10.3093 16.405 11.7636 15.3419 13.3349C14.2787 14.9062 12.6706 16.6079 10.5176 18.44Z",
    fill: "#676F83"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostLocation);
export default __webpack_public_path__ + "static/media/PostLocation.6e240fcb4637ec0ba146e30072244ecd.svg";
export { ForwardRef as ReactComponent };